enum ProtocolTypesEnum {
	OMBUDSMAN = 'OUVIDORIA',
	SAC = 'SAC',
	FINANCEIRO = 'FINANCEIRO',
}

enum ProtocolStatusEnum {
	COMPLETED = 'Concluída',
}

export {ProtocolTypesEnum, ProtocolStatusEnum};
